import { SidebarNavItem, SiteConfig } from "types";
import { getAppUrl } from "@/lib/urls";

const site_url = getAppUrl();

export const siteConfig: SiteConfig = {
  name: "QuantWheel",
  description:
    "Find which options to sell and when.",
  url: site_url,
  ogImage: `https://quantwheel.nyc3.cdn.digitaloceanspaces.com/qw-og.png`,
  links: {
    twitter: "https://twitter.com/quantwheel",
    github: "https://github.com/ivanoreh",
  },
  mailSupport: "hello@quantwheel.com",
};

export const footerLinks: SidebarNavItem[] = [
  {
    title: "Company",
    items: [
      { title: "About", href: "/about" },
      { title: "Pricing", href: "/pricing" },
      { title: "Documentation", href: "/documentation" },
      { title: "Webinars", href: "/webinars" },
      { title: "Terms", href: "/tos" },
      { title: "Privacy", href: "/privacy-policy" },
      { title: "Refund Policy", href: "/tos#refunds" },
    ],
  },
  {
    title: "Products",
    items: [
      { title: "All Products", href: "/products" },
      { title: "QW Intelligence (AI)", href: "/products/qw-intelligence" },
      { title: "Options Journal", href: "/products/options-journal" },
      { title: "Copy Trading", href: "/products/copy-trading" },
      { title: "Selling Screener", href: "/products/options-screener" },
      { title: "Buying Screener", href: "/products/options-screener-buyers" },
      { title: "Roll Assistant", href: "/products/roll-assistant" },
    ],
  },
  {
    title: "GEX Analytics",
    items: [
      { title: "GEX Dashboard", href: "/products/gex-dashboard" },
      { title: "Gamma Flows", href: "/products/gamma-flows" },
      { title: "Gamma Exposure", href: "/dashboard/gex/gamma" },
      { title: "Vanna & Charm", href: "/dashboard/gex/vanna-charm" },
      { title: "GEX Calculator", href: "/tools/gex-calculator" },
      { title: "GEX Heatmap", href: "/tools/gex-heatmap" },
      { title: "Max Pain Calculator", href: "/tools/max-pain-calculator" },
    ],
  },
  {
    title: "Free Tools",
    items: [
      { title: "GEX Calculator", href: "/tools/gex-calculator" },
      { title: "GEX Heatmap", href: "/tools/gex-heatmap" },
      { title: "Max Pain Calculator", href: "/tools/max-pain-calculator" },
      { title: "Earnings Expected Move Scanner", href: "/tools/mispriced-earnings" },
      { title: "Optimal Roll", href: "/tools/optimal-roll" },
      { title: "Options Calculator", href: "/tools/options-calculator" },
      { title: "Cash-Secured Put Calculator", href: "/tools/cash-secured-put-calculator" },
      { title: "Cost Basis After Assignment", href: "/tools/cost-basis-calculator" },
      { title: "Strategy Explorer", href: "/tools/strategy-explorer" },
    ],
  },
  {
    title: "Coming Soon",
    items: [
      { title: "AI Research Agents", href: "/products/ai-research-agents" },
      { title: "Gamma Flows", href: "/products/gamma-flows" },
    ],
  },
];
